/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Category_FeatureInputs */



/**
* | output |
* | --- |
* | "Feature idea" |
*
* @param {Feedback_Category_FeatureInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_category_feature = /** @type {((inputs?: Feedback_Category_FeatureInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Category_FeatureInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Idée de fonctionnalité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idea de funcionalidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ideia de funcionalidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Idea per una funzionalità")
	return /** @type {LocalizedString} */ ("Feature idea")
});